import { Badge, Box, Button, Group, Stack, Text } from '@mantine/core';

const TextInnerCell = ({ rowData }) => {
    return <Text>{rowData.content}</Text>;
};

const MmsInnerCell = ({ rowData }) => {
    return (
        <Button
            size={'compact-xs'}
            component='a'
            href={rowData.content}
            target={'_blank'}>
            View MMS
        </Button>
    );
};

const MessageContentCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                {rowData.type === 'Mms' ? (
                    <MmsInnerCell rowData={rowData} />
                ) : (
                    <TextInnerCell rowData={rowData} />
                )}
            </Stack>
        </Box>
    );
};

const MessageContentColumn = () => ({
    accessorKey: 'messageContent',
    header: 'Message Content',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <MessageContentCell cell={cell} />,
});
export default MessageContentColumn;
